import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IResourceState } from '@shared/models';
import * as Types from '@shared/models/resources/resource.type';
import { fetchResourcesByCategory } from '../queries';

const state: IResourceState = {
    fetching: false,
    data: [],
    filterOptions: {
        skills: [],
        gradeLevel: [],
    },
};

const resourceSlice = createSlice({
    name: 'resource',
    initialState: state,
    reducers: {
        setResources: (state, { payload }: PayloadAction<Types.ResourceType[]>) => {
            state.data = payload;
        },
        setResourceFilterOptions: (state, { payload }: PayloadAction<Types.ResourceFilterOptionType>) => {
            state.filterOptions = payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchResourcesByCategory.pending, (state) => {
            state.fetching = true;
        });
        builder.addCase(fetchResourcesByCategory.rejected, (state) => {
            state.fetching = false;
        });
        builder.addCase(fetchResourcesByCategory.fulfilled, (state) => {
            state.fetching = false;
        });
    },
});

export const { setResources, setResourceFilterOptions } = resourceSlice.actions;
export default resourceSlice.reducer;
